var _Circle, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgChainPolygon = function SvgChainPolygon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDF0F4"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M15.6 9.59c-.255-.147-.584-.147-.877 0l-2.047 1.214-1.389.773-2.01 1.214c-.256.147-.585.147-.878 0l-1.571-.957a.898.898 0 0 1-.439-.772v-1.84c0-.295.146-.589.439-.773l1.571-.92c.256-.147.585-.147.878 0l1.572.957a.898.898 0 0 1 .438.773v1.214l1.39-.81v-1.25a.909.909 0 0 0-.44-.773L9.314 5.91c-.256-.147-.585-.147-.877 0L5.439 7.676A.81.81 0 0 0 5 8.412v3.459c0 .294.146.589.439.773l2.96 1.73c.256.146.585.146.878 0l2.01-1.178 1.39-.81 2.01-1.177c.256-.147.585-.147.877 0l1.572.92a.898.898 0 0 1 .438.772v1.84a.909.909 0 0 1-.438.773l-1.535.92c-.256.147-.585.147-.878 0l-1.572-.92a.898.898 0 0 1-.438-.773v-1.177l-1.39.81v1.213c0 .295.147.59.44.773l2.96 1.73c.256.147.585.147.877 0l2.961-1.73a.898.898 0 0 0 .439-.773v-3.495a.909.909 0 0 0-.439-.773l-2.96-1.73Z",
    fill: "#8247E5"
  })));
};
export default SvgChainPolygon;